import { Services } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import buttonConfirm from '@/components/button/confirm'

function renderField(h, options) {
  const { path, serviceName } = options

  return h(
    components.select,
    {
      props: {
        value: this.proxy,
        label: this.getTranslate(`${serviceName}.labels.${path}`),
        items: this.paymentsMethods.map(method => {
          return {
            title: this.getTranslate(`${Services.payments}.methods.${method}`),
            value: method
          }
        }),
        disabled: this.paymentsMethods.length === 0,
        dense: true,
        multiple: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}

export default function(h, options) {
  if (this.checkPermissions(`advanced.${Services.settingsSite}.set`)) {
    return h(
      buttonConfirm,
      {
        props: {
          value: this.proxy,
          loading: this.loading,
          disabled: this.disabled
        },
        on: {
          input: () => {
            this.submit()
          }
        }
      },
      [ renderField.call(this, h, options) ]
    )
  }
}
